import { ChevronDownIcon } from '@heroicons/react/24/outline'

export default function SelectField({
  label,
  id,
  required = false,
  children,
  className = '',
  ...props
}) {
  return (
    <div className="space-y-2 w-full flex-1">
      {label && (
        <label
          htmlFor={id}
          className="flex items-center text-sm font-medium text-foreground-muted font-inter"
        >
          {label}
          {required && <span className="text-error-900 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        <select
          id={id}
          name={id}
          required={required}
          className={`block w-full h-10 px-3 py-2 bg-secondary-50 border border-gray-200 rounded-md text-sm font-medium text-foreground font-inter focus:outline-none focus:border-secondary-600 focus:ring-1 focus:ring-secondary-600/20 transition-colors appearance-none ${className}`}
          {...props}
        >
          {children}
        </select>
        <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
      </div>
    </div>
  )
}
